@if (preload()) {
  <div class="loader-hld full-page">
    <div class="centered-hld">
      <div class="loader"></div>
    </div>
  </div>
}
